
define('text!plugins/date/template.html',[],function () { return '<div class=\'row\'>\n    <div class=\'large-12 small-centered columns\'>\n        <input type=\'text\' class=\'datetimepicker\' data-rv-id=\'model:_id\' data-rv-placeholder=\'model:type\' data-rv-value=\'model:value\'>\n    </div>\n</div>\n';});

